<template>
    <v-btn-toggle v-model="query.state" borderless active-class="white elevation-4" color="primary" class="grey lighten-4" style="width:100%;border-radius:8px!important" @change="emit">
        <template v-for="{ text, value } in states">
            <v-btn :width="`calc(100% / ${states.length})`" style="border-radius: 8px!important;" v-bind="{ value }" :key="text">
                <template v-if="detect === 'pc'">
                    <span> {{ text }} </span>
                </template>
                <template v-else>
                    <span style="white-space:pre-line;line-height:1.2!important">
                        {{ `${text.slice(0, 2)}\n${text.slice(2)}` }}
                    </span>
                </template>
            </v-btn>
        </template>
    </v-btn-toggle>
</template>

<script>
import detect from "@/plugins/detect";
import { List_NshopOrder_State } from "@/store/nshop";

const initQuery = (form = {}) => ({
    ...(form || {}),
    state: form?.state || null,
});
const states = List_NshopOrder_State;

export default {
    data: () => ({
        query: initQuery(),

        detect,
        states,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (!query.state) delete query.state;

            this.$router.push({ query });
        },
    },
};
</script>

<style lang="scss" scoped>
.v-btn-toggle > .v-btn.v-btn--active {
    opacity: 1;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn--active.white {
    border-width: 1px;
    border-style: solid;
    border-color: var(--v-primary-base) !important;
}
</style>
